export default __webpack_public_path__ + "static/media/ic_vatican_city.f6cb863a.svg";